import { render, staticRenderFns } from "./Stamps.vue?vue&type=template&id=5f9896fd&scoped=true"
import script from "./Stamps.vue?vue&type=script&lang=js"
export * from "./Stamps.vue?vue&type=script&lang=js"
import style0 from "./Stamps.vue?vue&type=style&index=0&id=5f9896fd&prod&lang=scss&scoped=true"
import style1 from "./Stamps.vue?vue&type=style&index=1&id=5f9896fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9896fd",
  null
  
)

export default component.exports